import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'
import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'

export const LedgerAccountLinkStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  useOnNext(() => Promise.resolve())

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_2.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_2.subtitle')}
    >
      <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('banking.accounts.accounting.ledger_account')}
        </Text.Normal>
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('banking.accounts.accounting.accounting_account_label')}
        </Text>
        <Box width="full">
          {!!data.legalEntity && (
            <LedgerAccountSelector
              legalEntityId={data.legalEntity.id}
              currentLedgerAccountName={data.ledgerAccountName}
              types={['bank']}
              disabled={false}
              onSelect={(id) => null}
              onEntitySelect={(entity) => {
                onDataChanged({
                  ...data,
                  ledgerAccountId: entity?.id ?? null,
                  ledgerAccountName: formatAccountName(entity) ?? null,
                })
              }}
            />
          )}
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
